import { Controller } from "@hotwired/stimulus"
import StartToastifyInstance from "toastify-js";

export default class extends Controller {
  static targets = [ "source" ]

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.innerHTML.replace(/(\r\n|\n|\r)/gm, "").trim());
    StartToastifyInstance({
      text: "Copiado!",
      duration: 3000,
      close: true,
      gravity: "top",
      position: "right",
      backgroundColor: "#2d3748",
      stopOnFocus: true,
    }).showToast();
  }
}